import { useState, useEffect } from 'react';

import { fetchUserCity, PROVINCE, getProvincePrincipalCity } from '@ratehub/base-ui';

import { useIntl } from 'react-intl';
import enrichAllProductGroups from '../functions/enrichAllProductGroups';


const DEFAULT_PROVINCE = PROVINCE.ONTARIO;

export default function useFeaturedProducts({ verifyLocation, productGroups, hideCTAIfNotMonetized }) {
    const { locale } = useIntl();

    const [ city, setCity ] = useState(() => getProvincePrincipalCity(DEFAULT_PROVINCE));
    const [ isLocationVerified, setIsLocationVerified ] = useState(false);


    useEffect(() => {
        if (typeof window === 'undefined') {
            return false;
        }

        if (verifyLocation) {
            if (!isLocationVerified) {
                verifyOrUpdateLocation();
            }
        } else {
            setIsLocationVerified(true);
        }
    }, [ isLocationVerified, verifyLocation ]);

    async function verifyOrUpdateLocation() {
        const userCity = await fetchUserCity() ?? getProvincePrincipalCity(DEFAULT_PROVINCE);

        setCity(userCity);

        // only re-fetch and enrich if province changes
        if (userCity.province.code !== city.province.code) {
            await enrichAllProductGroups(productGroups, {
                locale,
                province: userCity.province.code,
                hideCTAIfNotMonetized,
            });
        }

        setIsLocationVerified(true);
    }

    return {
        // loading state
        isLocationVerified,

        // data
        city,
        get provinceCode() {
            return this.city.province.code;
        },
    };
}

